import { SectionContainer } from "@silversea-ssc/ui-components-react";
import PageBuilderBlogMosaic from "components/PageBuilder/PageBuilderBlogMosaic";
import React from "react";
import { PageBuilderBlogSectionFragment } from "types/graphql-types";

type Props = {
  withPrePost: boolean;
  blog: PageBuilderBlogSectionFragment;
};

const BlogSection: React.FC<Props> = ({ blog, withPrePost }) => {
  return (
    <div id="stories" className="hide-print">
      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        dataContentName="stories"
        backgroundColor={withPrePost ? "white" : "neutral05"}
      >
        <PageBuilderBlogMosaic
          content={blog}
          cardBackgroundColor={withPrePost ? "neutral01" : "white"}
        />
      </SectionContainer>
    </div>
  );
};

export default BlogSection;
